import "./Calling.scss";
import React from "react";
import App, { InterfaceAppState, InterfaceEasyCallMeState } from "../../App";
import { Button } from "@mui/material";
import { SessionState } from "sip.js";
import { withTranslation } from 'react-i18next';
import { HelperUtil } from "../../utils/helper";

class Calling extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {};

    }

    render() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        const selectedCam = AppState.selectedCamera;
        const { t } = this.props;

        return (
            <>
                <div id="page-calling" className={(AppComp.state.withStyle ? 'with-style ' : '')}>
                    <video id="local-video" controls={false} autoPlay={true} muted={true} />

                    {/* {selectedCam && !AppState.audioOnly ? "on-screen-message with-video" :
                            ("on-screen-message " + (AppComp.state.withStyle ? 'with-style ' : ''))} */}

                    {this.props.AppState.sessionState !== SessionState.Terminated && <div id="calling-box"
                        //className={(AppComp.state.withStyle ? 'with-style ' : '')}
                        className={(selectedCam && !AppState.audioOnly ? "with-video" : '') +
                            (AppComp.state.withStyle ? 'with-style ' : '')}
                    >
                        <span
                            className={(selectedCam && !AppState.audioOnly ? 'text with-video' : 'text') +
                                (AppComp.state.withStyle ? ' with-style' : '')}>{t('calling')}</span>
                        <div className="controls">
                            <Button onClick={() => {
                                this.props.AppComp.endCall();
                            }} color="error" variant="contained">{t('hangup')}</Button>
                        </div>
                        <div className={'footer-text'}>
                            {t('easy-call-me.access_page_footer_text', { "current-year": (new Date()).getFullYear().toString() })}
                        </div>
                    </div>}
                </div>
                {this.props.AppState.sessionState === SessionState.Terminated &&
                    <div
                        className={selectedCam && !AppState.audioOnly ? "on-screen-message with-video" :
                            ("on-screen-message " + (AppComp.state.withStyle ? 'with-style ' : ''))}>
                        <div>
                            <span className='text'>{t('call_terminated')}</span>
                            {AppState.rejectReason &&
                                <div style={{ fontSize: '20px', marginTop: '5px', marginBottom: '25px' }}>
                                    {AppState.rejectReason}
                                </div>}
                            {AppState.terminateReason &&
                                <div style={{ fontSize: '20px', marginTop: '5px', marginBottom: '25px' }}>
                                    {AppState.terminateReason}
                                </div>}
                            {!AppState.rejectReason && <div style={{ fontSize: '20px', marginTop: '10px' }}>
                                {t('call_duration')}: {AppComp.toTimeString(AppState.lastCallDurationSeconds)}
                            </div>}
                            <div className={"controls " + (AppComp.state.withStyle ? 'with-style ' : '')}>
                                <Button onClick={() => {
                                    AppComp.clearSession();
                                    if (selectedCam) {
                                        AppComp.setAudioOnly(false, (value) => {
                                            AppComp.initPreviewVideo();
                                        })
                                    }
                                    if (AppState.keepAutoStart) { //if keepAutoStart => began as request_data
                                        var state: InterfaceEasyCallMeState = {
                                            name: "",
                                            lastName: "",
                                            email: "",
                                            errorName: false,
                                            errorLastName: false,
                                            errorEmail: false,
                                            showAudioVideoSettings: false,
                                            domain: (window as any)._easy_link_config.domain,
                                            next_url: AppState.EasyCallMeBackup?.next_url ?? "",
                                            api_url: AppState.EasyCallMeBackup?.api_url ?? "",
                                            mode: (window as any)._easy_link_config.mode
                                        };
                                        AppComp.setState({
                                            EasyCallMe: state
                                        })
                                    }
                                }} variant="contained">{t('return_to_landing')}
                                </Button>
                                <Button onClick={() => {
                                    const selectedMic = AppState.selectedMicrophone;
                                    const selectedCam = AppState.selectedCamera;

                                    if (selectedMic) {
                                        const constraints: MediaStreamConstraints = {
                                            audio: { deviceId: selectedMic.deviceId },
                                            video: (selectedCam && !AppState.audioOnly) ? { deviceId: selectedCam.deviceId } : false,
                                        };

                                        AppComp.call(AppState.configurations?.call_destination, constraints);
                                    } else {
                                        console.error('No audio device found, call will not be made');
                                    }
                                }} variant="contained">{t('recall')}</Button>
                            </div>
                        </div>
                        <div className={'footer-text-terminated'}>
                            {t('easy-call-me.access_page_footer_text', { "current-year": (new Date()).getFullYear().toString() })}
                        </div>
                    </div>

                }

            </>
        );
    }

    componentDidMount() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        const selectedCam = AppState.selectedCamera;

        if (selectedCam && !AppState.audioOnly) {
            const constraints: MediaStreamConstraints = {
                audio: false,
                video: { deviceId: selectedCam.deviceId }
            };

            AppComp.stopStream(null);
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                if (HelperUtil.showLogs()) {
                    console.log('The stream was successfully obtained', stream);
                }
                if (stream) {
                    AppComp.stream = stream;
                    AppComp.setupStreamToVideo(stream, 'local-video', () => {
                    }, () => {
                    });
                }
            }).catch((err) => {
                if (err) {
                    console.error('There was an error obtaining the stream', err);
                }
            });
        }
    }
}

export default withTranslation()(Calling);
